/**
 * PsicoSalud — Definición de rutas.
 *
 * Cada ruta protegida corresponde a un módulo de la ficha del proyecto:
 * agenda (M1), pacientes e historial (M2), sesión remota (M3),
 * evaluaciones (M4) e indicadores de IA (M5).
 */

import { Navigate, Route, Routes } from 'react-router-dom';

import Layout from '@/components/Layout';
import ProtectedRoute from '@/components/ProtectedRoute';
import AgendaPage from '@/pages/AgendaPage';
import AnalyticsPage from '@/pages/AnalyticsPage';
import ClinicalRecordPage from '@/pages/ClinicalRecordPage';
import DashboardPage from '@/pages/DashboardPage';
import FormsPage from '@/pages/FormsPage';
import LoginPage from '@/pages/LoginPage';
import PatientDetailPage from '@/pages/PatientDetailPage';
import PatientsPage from '@/pages/PatientsPage';
import UsersPage from '@/pages/UsersPage';
import VideoSessionPage from '@/pages/VideoSessionPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/agenda" element={<AgendaPage />} />
        <Route path="/pacientes" element={<PatientsPage />} />
        <Route path="/usuarios" element={<UsersPage />} />
        <Route path="/pacientes/:patientId" element={<PatientDetailPage />} />
        <Route path="/pacientes/:patientId/historial" element={<ClinicalRecordPage />} />
        <Route path="/pacientes/:patientId/evaluaciones" element={<FormsPage />} />
        <Route path="/pacientes/:patientId/indicadores" element={<AnalyticsPage />} />
        <Route path="/consultas/:appointmentId/sesion" element={<VideoSessionPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
